import React, {FunctionComponent, useState} from "react";
import "./mediaPageStyle.css";
import bannerImg from "../../assets/contact.jpg";
import {Banner} from "../../components/Banner";
import {Section} from "../../components/Section";
import YouTubePlayer from "../../components/YoutubePlayer";
import {MEDIA_VIDEO_IDS} from "../../constants/mediaVideos";

export const MediaPage: FunctionComponent = () => {
    const [readyCount, setReadyCount] = useState(0);
    const allReady = readyCount >= MEDIA_VIDEO_IDS.length;

    const handleReady = () => setReadyCount((c) => c + 1);

    return (
        <div className={"media"}>
            <Banner banner={bannerImg} pageTitle={"Media"} />
            <Section>
                <div className={"media__container lg__container-padding"}>
                    <div className={`video-section ${allReady ? "" : "video-section--hidden"}`}>
                        {MEDIA_VIDEO_IDS.map((videoId) => (
                            <YouTubePlayer
                                key={videoId}
                                videoId={videoId}
                                onReady={handleReady}
                            />
                        ))}
                    </div>
                    {!allReady && (
                        <div className={"media__loader"}>
                            <div className={"media__spinner"} />
                            <p className={"media__loader-text"}>Chargement des vidéos...</p>
                        </div>
                    )}
                </div>
            </Section>
        </div>
    );
};
